export default "__VITE_ASSET__4d106f58__"